import { Button } from '../../../../../components/Toolkit/Button/Button';
import { AddCircleOutlineIc } from '@dsch/dd-icons';
import {
  ResponseMakeModelFilterValue,
  ResponseModelFilter,
  IGetSearchFilterMakeModel,
} from '../../../../../types';
import styled from 'styled-components';
import { Spacer } from '../../../../../components/DealerPage/styles';
import { MakeModelGroupSelect } from '../../../../../components/DealerPage/components/Filters/MakeModelSelectGroup/MakeModelSelectGroup';
import { MakeModelType } from '../../../../../components/DealerPage/hooks/useFiltersMakeModel';

export interface IListMultiSelectMakeModelProps {
  section: string;
  makeModel: MakeModelType;
  makeModelData: {
    make: ResponseMakeModelFilterValue;
    model: ResponseModelFilter;
  };
  addNewMakeModel: () => void;
  handleOnUpdateMake: (id: string, value: string) => void;
  handleOnAddModel: (id: string, value: string) => void;
  handleOnRemoveModel: (id: string, value: string) => void;
  handleOnRemoveMakeModel: (id: string) => void;
  handleResetModel: (id: string) => void;
  reset: () => void;
  isAddAnotherEnabled: boolean;
  dealerId?: string;
}

type TMakeModelValue = {
  valueType?: string;
  displayName?: string;
  value?: string;
};

const mapMakeModelToOptions = (makeModels?: TMakeModelValue[]) =>
  makeModels
    ? makeModels.map((item) => ({
        value: item.value ?? '',
        displayName: item.displayName ?? '',
      }))
    : [];

const SButton = styled(Button)``;

const MakeModelHeading = styled.span`
  display: block;
  ${({ theme }) => theme.fontSize.M16};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;

function ListMultiSelectMakeModel({
  section,
  makeModel,
  makeModelData,
  addNewMakeModel,
  handleOnUpdateMake,
  handleOnAddModel,
  handleOnRemoveMakeModel,
  handleOnRemoveModel,
  handleResetModel,
  isAddAnotherEnabled,
  dealerId,
}: IListMultiSelectMakeModelProps) {
  const makeAll = mapMakeModelToOptions(makeModelData.make.all);
  const makePopular = mapMakeModelToOptions(makeModelData.make.popular);

  const makeOptions =
    makePopular && makePopular.length > 0
      ? [
          { value: '', displayName: 'All Makes' },
          { value: '', displayName: 'Popular' },
          ...makePopular,
          { value: '', displayName: 'All Makes' },
          ...makeAll,
        ]
      : [{ value: '', displayName: 'All Makes' }, ...makeAll];

  makeOptions.map((makeOption) => ({
    ...makeOption,
    isDisabled: !!makeModel.find(
      (makeModelItem) => makeModelItem.makeValue === makeOption.displayName,
    ),
  }));

  return (
    <div>
      {makeModel.length > 0 &&
        makeModel
          .sort((a, b) => Number(a.isEditable) - Number(b.isEditable))
          .map((makeModelGroup, index) => {
            const makeValue = !!makeModelGroup.makeValue
              ? makeModelGroup.makeValue
              : makeOptions[0].displayName;

            const modelsByMake:
              | IGetSearchFilterMakeModel
              | boolean
              | undefined =
              makeModelData.model.length > 0 &&
              makeModelData.model.find(
                (modelItem) => modelItem.makeName === makeValue,
              );

            const modelOptions = modelsByMake
              ? [
                  { value: '', displayName: 'All Models' },
                  { value: '', displayName: 'Popular' },
                  ...mapMakeModelToOptions(modelsByMake.popular),
                  { value: '', displayName: 'All Models' },
                  ...mapMakeModelToOptions(modelsByMake.all),
                ]
              : [];

            return (
              index < 3 && (
                <div key={makeModelGroup.id}>
                  {makeModelGroup.isEditable && (
                    <MakeModelHeading> Make/Model </MakeModelHeading>
                  )}

                  <MakeModelGroupSelect
                    id={makeModelGroup.id}
                    section={section}
                    makeOptions={makeOptions}
                    makeValue={makeValue ?? ''}
                    modelValue={makeModelGroup.modelValue}
                    modelOptions={modelOptions}
                    onMakeChange={handleOnUpdateMake}
                    onAddModel={handleOnAddModel}
                    onRemoveModel={handleOnRemoveModel}
                    onClear={handleResetModel}
                    isEditable={makeModelGroup.isEditable}
                    onRemove={handleOnRemoveMakeModel}
                    dealerId={dealerId}
                  />

                  {!makeModelGroup.isEditable && index === 2 && (
                    <MakeModelHeading> Make/Model </MakeModelHeading>
                  )}
                </div>
              )
            );
          })}

      {makeModel.length > 0 && makeModel.length <= 2 && (
        <>
          <SButton
            ofType="SECONDARY"
            onClick={addNewMakeModel}
            icon={<AddCircleOutlineIc />}
            disabled={!isAddAnotherEnabled}
          >
            Add another
          </SButton>
          <Spacer />
        </>
      )}
    </div>
  );
}

export { ListMultiSelectMakeModel };
